import styled from 'styled-components';
import mq, { breakpointVals } from '../utils/mediaQuery';
import { svgWidth } from './styled-utils';
import { ReactComponent as LogoDark } from '@/src/resources/logo.svg';

const mqDesktopNav = mq(`(min-width: ${breakpointVals.large + 1}px)`);

export const StyledDarkLogo = styled(LogoDark)`
  width: 50px;
  display: block;
  line-height: 0;

  ${mqDesktopNav(`
    ${svgWidth('50px', 48, 48)}
  `)}
`;
